/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
import { Remediator } from './Base/Remediator';
export class EnrollPoll extends Remediator {
    canRemediate() {
        return Boolean(this.values.startPolling);
    }
    getNextStep(context) {
        const common = super.getNextStep(context);
        let authenticator = this.getAuthenticator();
        if (!authenticator && (context === null || context === void 0 ? void 0 : context.currentAuthenticator)) {
            authenticator = context.currentAuthenticator.value;
        }
        return Object.assign(Object.assign({}, common), { authenticator, poll: {
                required: true,
                refresh: this.remediation.refresh
            } });
    }
    getValuesAfterProceed() {
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== 'startPolling');
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
EnrollPoll.remediationName = 'enroll-poll';
